import 'core-js/stable'
import 'regenerator-runtime/runtime'
import DOMMatrix from 'dommatrix'
import ResizeObserver from 'resize-observer-polyfill'
import GaiFlow from './GaiFlow'

window.ResizeObserver = ResizeObserver
window.DOMMatrixReadOnly = DOMMatrix

window.KDApi.register('ai-gai-gpt-flow', GaiFlow)
